/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import aboutCompanyModule from "./about.company.module";
import aboutModule from "./about.module";
import brochureModule from "./brochure.module";
import commonModule from "./common.module";
import { contactModule } from "./contact";
import customPageModule from "./custom.page.module";
import editUserProfileModule from "./edit-user-profile.module";
import { garageModule } from "./garage";
import inventoryModule from "./inventory.module";
import inventoryVautoFilterModule from "./inventory.vauto.filter.module";
/*import content from "../../config/content";
import settings from "../../config/settings";*/
import loginModule from "./login.module";
import meetTheTeamModule from "./meet.the.team.module";
import ownersModule from "./owner.module";
import recommendFriendModule from "./recommend.friend.module";
import standaloneModule from "./standalone.module";
import videoMessageModule from "./video.message.module";


let storeDescription = {
  modules: {
    common: commonModule,   
    login: loginModule,
    brochure: brochureModule,
    aboutCompany: aboutCompanyModule,
    editUserProfile: editUserProfileModule,
    about: aboutModule,
    videoMessage: videoMessageModule,
    recommendFriend: recommendFriendModule,
    standalone : standaloneModule,
    ownerManual:ownersModule,
    customPage: customPageModule,
    meetTheTeam:meetTheTeamModule,
    inventory:inventoryModule,
    inventoryVautoFilter:inventoryVautoFilterModule,
    garage: garageModule,
    contact: contactModule
  },
  actions: {
    init: function(context, payload) {
      return new Promise(resolve => {
        //using promise to detect the moment when init completed
        context.dispatch("login/init").then(() => {
          resolve();
        });
      });
    }
  },
  strict: process.env.NODE_ENV !== "production" // enable it only for dev "to avoid the performance cost on prod."
};

Vue.use(Vuex);

const store = new Vuex.Store(storeDescription);

export default store;



// WEBPACK FOOTER //
// ./scripts/src/store/index.js